import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { TravelerComponent } from '../traveler/traveler.component';

@Component({
  selector: 'app-preregister-list',
  templateUrl: './preregister-list.component.html',
  styleUrls: ['./preregister-list.component.css']
})
export class PreregisterListComponent implements OnInit {

  public menu_item_id = '114';
  public add_auth;
  public edit_auth;
  public del_auth;
  
  private dp = [];
  displayedColumns = ['acct_number', 'customer_name', 'national_id', 'mobile', 'passport_no',  
    'companion', 'bank_name', 'bank_acct_number', 'trip_name', 'invoice_no', 'register', 'edit', 'del'];
  displayedColumns2 = ['acct_number', 'customer_name', 'national_id', 'mobile', 'passport_no',
    'companion', 'bank_name', 'bank_acct_number', 'trip_name', 'invoice_no'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<TravelerComponent>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'customer', 'from_date': undefined, 'to_date': undefined, 'status': '1', 
    'customer_name': '', 'acct_number': '', 'mobile': '', 'phone1': '', 'national_id': '', 
    'passport_no': '', 'branch_id': '-1', 'title': 'قائمة التسجيل المسبق'
  };

  statusList = [{ 'status_id': '0', 'status_name': 'الكل', 'status_name_en': 'All' },
    { 'status_id': '1', 'status_name': 'بانتظار التسجيل', 'status_name_en': 'Waiting Registration' },
    { 'status_id': '2', 'status_name': 'تم التسجيل', 'status_name_en': 'Registered' }];

  branchList = [];
  Preregister_List; Success_Msg; Error_Msg; Del_Msg; Cancel_Prereg_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants, 
    public dialog: MatDialog, public translate: TranslateService) { 
      this.getMessages(translate);
    }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Preregister_List').subscribe((res: string) => {
      this.Preregister_List = res;
    });
    this.model['title'] = this.Preregister_List;

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
    
    translate.get('Cancel_Prereg_Msg').subscribe((res: string) => {
      this.Cancel_Prereg_Msg = res;
    });
  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.push({ 'branch_id': '0', 'branch_name': 'مشترك لجميع الفروع', 
          'branch_name_en': 'Common to all branches' });
        
        this.branchList.unshift({ 'branch_id': '-1', 'branch_name': 'الكل', 'branch_name_en': 'All' });

        this.search();
      });
  }

  search() {

    let obj = { cmd: 'getPreregList' };

    if (this.model['status'] != '1') {

      if (this.model['from_date'] != undefined) {
        let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) +
          "-" + this.model['from_date'].getDate() + ' 00:00:00';
        
        obj['from_date'] = from_date;
      }
  
      if (this.model['to_date'] != undefined) {
        let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) +
          "-" + this.model['to_date'].getDate() + ' 23:59:59';
          
        obj['to_date'] = to_date;
      }
    }

    if (this.model['status'] != '0') 
      obj['status'] = this.model['status'];

    if (this.model['customer_name'] != '') 
      obj['customer_name'] = this.model['customer_name'];

    if (this.model['mobile'] != '') 
      obj['mobile'] = this.model['mobile'];

    if (this.model['phone1'] != '') 
      obj['phone1'] = this.model['phone1'];
   
    if (this.model['passport_no'] != '') 
      obj['passport_no'] = this.model['passport_no'];

    if (this.model['branch_id'] != '-1') 
      obj['branch_id'] = this.model['branch_id'];
    else {
      let branch_list = [];
      this.branchList.forEach(element => {
        if (element.branch_id != '-1')
          branch_list.push({ 'branch_id': element.branch_id });
      });
      obj['branch_list'] = branch_list;
    }

    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];

        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  regTraveler(row) {

    // let values = [{ 'table_name': this.model['table_name'], 'status': '1' }];
    // let where = [{ 'customer_id': row.customer_id }];
    // let obj = { cmd: 'update', values: values, where: where };

    //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //     .subscribe(data => {
    //       this.applicationConstants.appComp.hideBusyCursor();
    //       if (data.status['type'] == 'success') {
    //         alert(this.Success_Msg);
    //         this.search();
    //       }
    //       else 
    //         alert(this.Error_Msg);
          
    //     });
  }

  editTraveler(row) {
    let dialog_data = [{
      'table_name': 'customer', 'customer_id': row.customer_id,
      'customer_name': row.customer_name,
      'customer_name_en': row.customer_name_en,
      'customer_last_name': row.customer_last_name,
      'acct_number': row.acct_number,
      'customer_category_id': row.customer_category_id,
      'city_id': row.city_id,
      'tax_no': row.tax_no,
      'address': row.address,
      'mobile': row.mobile,
      'phone1': row.phone1,
      'phone2': row.phone2,
      'fax': row.fax,
      'email': row.email,
      'represent1': row.represent1,
      'represent1_mobile': row.represent1_mobile,
      'represent2': row.represent2,
      'represent2_mobile': row.represent2_mobile,
      'def_rep_no': row.def_rep_no,
      'claim_day': row.claim_day,
      'comment': row.comment,
      'key': 'customer_id',
      'flag': 'update',
      'car_type': row.car_type,
      'car_model': row.car_model,
      'car_color': row.car_color,
      'is_account': row.is_account
    }, { 'country_id': row.country_id }];

    this.addDialogRef = this.dialog.open(TravelerComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success') {
          this.search();
        }
      });

  }

  cancelReg(row) {
    if (confirm(this.Cancel_Prereg_Msg)) {
      let values, where, obj;

      values = [{ 'table_name': 'traveler_info', 'reg_from': '', 'trip_id': '0' }];
      where = [{ 'acct_number': row.acct_number }];
      obj = { cmd: 'update', values: values, where: where };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.status['type'] == 'success') {

            values = [{ 'table_name': 'traveler_trip', 'acct_number': row.acct_number }]
            obj = { cmd: 'deleteRec', values: values };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                if (data.status['type'] == 'success') {
                  alert(this.Success_Msg);
                  this.search();
                }
                else
                  alert(this.Error_Msg);
              });
          }
          else 
            alert(this.Error_Msg);
        });
    }
  }

  delTraveler(row) {
    if (confirm(this.Del_Msg)) {

      let values = [{ 'table_name': this.model['table_name'], 'acct_number': row.acct_number },
        { 'table_name': 'traveler_info', 'acct_number': row.acct_number },
        { 'table_name': 'sub_acct', 'acct_number': row.acct_number }];

      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else 
            alert(this.Error_Msg);
          
        });
    }
  }

  print() {
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.Preregister_List + ' </td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('customer_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
